<template>
  <div class="div-err">
    <img src="../../../static\images\err.png" />
    <div class="err">
      <span>{{ $t("err.err4") }}</span>
      <button @click="revertHomePage()" class="buttons__revert" role="button">{{ $t("err.revertErr")}}</button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    methods: {
      revertHomePage() {
        this.$router.push('/home/index');
      },
    },
  };
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-err {
  height: 100%;
  display: flex;
  align-items: center;
}
.main {
  padding-top: 60px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.err {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 50px;
}

.err span {
  font-weight: 700;
}

/* CSS */
.buttons__revert {
  align-items: center;
  appearance: none;
  background-image: radial-gradient(100% 100% at 100% 0, #5adaff 0, #0071c5 100%);
  border: 0;
  border-radius: 6px;
  box-shadow: rgba(45, 35, 66, .4) 0 2px 4px,rgba(45, 35, 66, .3) 0 7px 13px -3px,rgba(58, 65, 111, .5) 0 -3px 0 inset;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-family: "JetBrains Mono",monospace;
  height: 48px;
  justify-content: center;
  line-height: 1;
  list-style: none;
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
  text-align: left;
  text-decoration: none;
  transition: box-shadow .15s,transform .15s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  will-change: box-shadow,transform;
  font-size: 18px;
}

.buttons__revert:focus {
  box-shadow: #0071c5 0 0 0 1.5px inset, rgba(45, 35, 66, .4) 0 2px 4px, rgba(45, 35, 66, .3) 0 7px 13px -3px, #3c4fe0 0 -3px 0 inset;
}

.buttons__revert:hover {
  box-shadow: rgba(45, 35, 66, .4) 0 2px 4px,rgba(45, 35, 66, .3) 0 7px 13px -3px,rgba(58, 65, 111, .5) 0 -3px 0 inset;
  transform: translateY(-2px);
}

.buttons__revert:active {
  box-shadow: #3c4fe0 0 3px 7px inset;
  transform: translateY(2px);
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .container,
  .bigCourse {
    width: 400px;
  }
}
.primarylists {
  padding-top: 90px;
  margin-left: 180px;
}

.primarylists ul li span {
  display: block;
  color: black;
  margin-left: 300px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/errApi.vue